import { render, staticRenderFns } from "./back-button.vue?vue&type=template&id=51249888&scoped=true"
import script from "./back-button.vue?vue&type=script&lang=js"
export * from "./back-button.vue?vue&type=script&lang=js"
import style0 from "./back-button.vue?vue&type=style&index=0&id=51249888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51249888",
  null
  
)

export default component.exports